import type { TableCellProps } from '@mui/material';
import { TableCell, Typography } from '@mui/material';

type DataDashboardTableHeaderCellProps = {
  text: string;
} & TableCellProps;

export const DataDashboardTableHeaderCell: React.FC<DataDashboardTableHeaderCellProps> = ({ text, ...props }) => {
  return (
    <TableCell {...props}>
      <Typography
        variant='body2'
        color={theme => theme.palette.text.secondary}
      >
        {text}
      </Typography>
    </TableCell>
  );
};